import { render, staticRenderFns } from "./AccountBody.vue?vue&type=template&id=8bbefa4a"
import script from "./AccountBody.vue?vue&type=script&lang=js"
export * from "./AccountBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountInfo: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountInfo.vue').default,AccountHistory: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountHistory.vue').default,AccountPayments: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountPayments.vue').default,AccountOffers: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountOffers.vue').default,AccountRewardsSingle: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountRewardsSingle.vue').default,AccountLocations: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/sections/AccountLocations.vue').default})
